import { Button } from "@/components/Buttons/index";
import {
  SingleCheckboxField,
  ErrorMessage,
} from "@/components/Form/Parts/index";
import styles from "@/styles/Form.module.scss";
import modalStyles from "@/styles/Modal.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import Link from "next/link";
import { useForm } from "react-hook-form";
import * as y from "yup";
import { useMemo } from "react";
import { useAuthUserQuery } from "@/hooks";

const schema = y.object().shape({
  terms: y.boolean().oneOf([true], "規約に同意してください。"),
});

export default function TermAgreementForm({ terms, onSubmit, agreementError }) {
  const { formState, register, handleSubmit } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
  });
  const { isDirty, isValid, errors } = formState;

  const { data } = useAuthUserQuery({
    variables: {},
  });

  const { receiveAdvertisingMailType } = data?.user || {};

  const requiredTerms = useMemo(() => {
    return terms.filter((term) => term.required);
  }, [terms]);

  const adTerm = useMemo(() => {
    if (terms) {
      const term = terms.find((term) => term.id_key === "ad");
      if (term) {
        return {
          link: term.current_revision.url,
          value: term.current_revision.unique_key,
        };
      }
    }
    return null;
  }, [terms]);

  const mailTerm = useMemo(() => {
    if (terms) {
      const key = "spoox_mail";
      const term = terms.find((term) => term.id_key === key);
      if (term) {
        return {
          link: term.current_revision.url,
          value: term.current_revision.unique_key,
        };
      }
    }
    return null;
  }, [terms]);

  const showMailTerm = useMemo(() => {
    if (
      (receiveAdvertisingMailType == 0 || receiveAdvertisingMailType == 1) &&
      mailTerm
    ) {
      return true;
    }

    return false;
  }, [mailTerm, receiveAdvertisingMailType]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <div>
        <h3>規約が更新されました</h3>
        <p className={modalStyles.lead}>
          利用規約を再度お読みいただき、「同意する」にチェックをしてから「同意する」ボタンを押してください。
        </p>
        {adTerm && (
          <fieldset
            className={`${styles.basicFieldset} ${styles.vwScale} ${styles.termAgreementForm}`}
          >
            <SingleCheckboxField
              {...register("termsAd")}
              title="広告におけるデータ利用の確認と同意"
              defaultChecked={false}
              vwScale
              label={
                <p className={styles.terms}>
                  本サービスの利用状況等をお客様の趣味・嗜好等に合致した情報の提供等に利用することに同意する(詳細は
                  <Link
                    href={adTerm.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    こちら
                  </Link>
                  )
                </p>
              }
              error={errors.termsAd?.message}
            />
          </fieldset>
        )}
        {showMailTerm && (
          <fieldset
            className={`${styles.basicFieldset} ${styles.vwScale} ${styles.termAgreementForm}`}
          >
            <SingleCheckboxField
              {...register("termsMail")}
              title="ご案内メールへの同意"
              defaultChecked={false}
              vwScale
              label={
                <p className={styles.terms}>
                  本サービスからのご案内メールの送付に同意する(詳細は
                  <Link
                    href={mailTerm.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    こちら
                  </Link>
                  )
                </p>
              }
              error={errors.terms_mail?.message}
            />
            {agreementError && <ErrorMessage msg={agreementError} />}
          </fieldset>
        )}
        {requiredTerms && requiredTerms.length > 0 && (
          <fieldset
            className={`${styles.basicFieldset} ${styles.vwScale} ${styles.termAgreementForm}`}
          >
            <SingleCheckboxField
              {...register("terms")}
              title="規約の確認と同意"
              defaultChecked={false}
              vwScale
              label={
                <p className={styles.terms}>
                  {requiredTerms.map((term) => {
                    if (term?.current_revision?.url) {
                      return (
                        <Link
                          key={`${term.id_key}-link`}
                          href={term?.current_revision?.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {term.display_name}
                        </Link>
                      );
                    }
                  })}
                  を確認の上、同意する
                </p>
              }
              error={errors.terms?.message}
              required
            />
          </fieldset>
        )}
        <Button type="submit" fillColor large disabled={!isDirty || !isValid}>
          同意する
        </Button>
      </div>
    </form>
  );
}
